module.exports = __webpack_public_path__ + "d27bfafbe6bb43695bc1735ecb793624.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/elephant.svg
// module id = 86
// module chunks = 0